/**
 * Project : workspace
 * File    : StoreHeader.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.customer.store.component

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.app.composeapp.generated.resources.Res
import com.parmartechnologies.app.composeapp.generated.resources.customer_app
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.core.feature.business.model.Business
import component.dimension.ScreenDimension
import component.input.SearchBar
import org.jetbrains.compose.resources.painterResource
import theme.ThemeColor

@Composable
/**
 * Executes the store header operation.
 *
 * @receiver TODO
 * @param business The business.
 * @param viewModel The view model.
 * @param query The query.
 * @return Unit – no return value.
 */
fun StoreHeader(business: Business?, viewModel: AppViewModel, query: String) {
    Column(
        modifier = Modifier
            .width(ScreenDimension().width())
            .height(150.dp)
            .background(color = ThemeColor.shared().PrimaryColor)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(start = 12.dp)
        ) {
            Box(
                modifier = Modifier
                    .width(42.dp)
                    .height(42.dp)
                    .background(
                        color = Color.Transparent,
                        shape = RoundedCornerShape(22.dp)
                    )
            ) {
                Image(
                    painter = painterResource(Res.drawable.customer_app),
                    contentDescription = "",
                    modifier = Modifier.height(42.dp).width(42.dp).padding(4.dp)
                )
            }

//            Box(
//                modifier = Modifier
//                    .width(42.dp)
//                    .height(42.dp)
//                    .background(
//                        color = Color.Black,
//                        shape = RoundedCornerShape(22.dp)
//                    )
//            ) {
//                ImageView(param?.selectedBusiness?._id)
//            }
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(start = 8.dp)
            ) {
                Text(
                    business?.Name ?: "",
                    color = ThemeColor.shared().BusinessTitleColor,
                    fontSize = 20.sp,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.padding(bottom = 4.dp)
                )
//                Text(
//                    AddressUtill().getAddressToDisplayInSingleLine(business?.Address),
//                    color = Color.White,
//                    fontSize = 14.sp,
//                    fontWeight = FontWeight.Bold,
//                    modifier = Modifier.padding(bottom = 4.dp)
//                )
                Text(
                    //business?.noteOne ?: "",
                    "Order Accepting : 12:59 AM",
                    color = Color.White,
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.padding(bottom = 4.dp)
                )
                Text(
                    "Order Delivering : 06 : 00 PM - 12 : 00 PM",
                    color = Color.White,
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.padding(bottom = 4.dp)
                )
//                Text(
//                    business?.noteThree ?: "",
//                    color = Color.White,
//                    fontSize = 14.sp,
//                    fontWeight = FontWeight.Bold,
//                    modifier = Modifier.padding(bottom = 4.dp)
//                )
//                                Text(
//                                    "⭐ 4.5 • ⏱ 15 min",
//                                    color = Color.White,
//                                    fontSize = 14.sp,
//                                    fontWeight = FontWeight.Bold,
//                                    modifier = Modifier.padding(bottom = 50.dp)
//                                )
            }
        }
        SearchBar(
            viewModel,
            query,
            " Search Products"
        )
    }
}